import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import HowToVoteIcon from "@mui/icons-material/HowToVote";
import EditIcon from "@mui/icons-material/Edit";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import {
  Avatar,
  colors,
  ImageList,
  ImageListItem,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
  IconButton,
  Box,
  Button,
  Stack,
} from "@mui/material";
import dayjs from "../../util/dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import styled from "styled-components";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { T, TF } from "react-translator-component";
import profile from "../../assets/images/profile_img.png";
import { colors as farmColor } from "../../common/colors";
import VotesModel from "../Models/VotesModel";
import PostCommentButton from "../PostCommentButton";
import { styles } from "../../pages/styles";
import PostDescSeeMore from "../Phase2/PostDescSeeMore";
import Thumbnail from "../Phase2/Thumbnail";
import MultiMenu from "../MultiMenu";
import appServices from "../../services/app-services/appServices";
import { setGroupInfo } from "../../redux/Reducers/gcGroupReducer";
import { useAppDispatch } from "../../redux/store";
import {
  convertUserImage, findBlockData, getPostCreatorName,
  isClosedGroup, isPostCreator
} from "../../util/utils";
import { adjustUserInfo } from "../../util/MultiMenu";
import LikeDislikeButton from "../LikeDislikeButton";
import PostTags from "../PostTags";
import Separator from "../Separator";
import GroupIconImage from "../GreenCity/GroupIconImage";
import { createUpdatingPostState } from "../../util/CreatePost"

const ModalBackground = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: flex-end; /* Align items to the bottom */
  z-index: 9999;
`;

const ModalContainer = styled.div`
  background: white;
  border-radius: 8px;
  width: 100%;
  height: 85%;
  overflow-y: hidden;
  z-index: 9999;
`;
interface Props {
  post: any;
  showRanking?: boolean;
  showPostMenu?: boolean;
  showStatus?: boolean;
  showEventStatus?: boolean;
  rank?: number;
}
export default function PostCard({
  post,
  showRanking = false,
  showPostMenu = false,
  showStatus = false,
  showEventStatus,
  rank,
}: Props) {
  // 相対時間の有効化
  dayjs.extend(relativeTime);

  const dispatch = useAppDispatch();
  const [showVotesModal, setShowVotesModal] = useState<number>(0);
  const [votedOptionId, setVotedOptionId] = useState<number | null>(post?.voted_info?.my_votes[0] || null);
  const navigate = useNavigate();
  const { user } = useSelector((state: any) => state.userAuth);
  const { blocks } = useSelector((state: any) => state.blocks);
  const creator: any = post?.creator

  const handleReview = (groupInfo: any) => {
    // Dispatch action to save group details
    dispatch(
      setGroupInfo({
        user: groupInfo?.owner,
        owner: groupInfo?.owner,
        id: groupInfo?.id,
        groupName: groupInfo?.name,
        groupIsPublic: groupInfo?.group_type,
        groupImage: groupInfo?.group_icon,
        groupMainImage: groupInfo?.banner_image, // From state
        groupDesc: groupInfo?.description, // From state
        groupAnnouncements: groupInfo?.member_group_activities, // From state
        groupWebURLs: groupInfo?.social_links, // You can replace this with the actual value
        groupApprovalRequired: groupInfo?.approval_required,
        piiRequired: groupInfo?.personal_information_needed ? "YES" : "NO",
        groupIsLimited: true,
        groupMemberShipFeeAmount: groupInfo?.joining_fee_amount,
        isMonthly: groupInfo?.fee_type === "monthly", // Static value
        isPaid: groupInfo?.is_paid,
        groupPaymentField: groupInfo?.fee_amount,
        groupPaymentDescription: groupInfo?.fee_explanation,
        memberGroupUsers: groupInfo?.member_group_users,
        posts_count: groupInfo?.posts_count
      })
    );
  };

  const createdAt = (date: any) => {
    return dayjs(date).fromNow()
  }

  const fetchBlock: any = (post: any) => {
    if (!blocks) return
    // ナビゲータはブロックできないため早期返却
    if (post?.creator_type !== "User") return

    let targetId: number;
    let blockType: "User" | "MemberGroup";

    if (post?.member_group) {
      targetId = post.member_group?.id
      blockType = "MemberGroup"
    } else {
      targetId = creator?.id
      blockType = "User"
    }

    if (!targetId) return

    return findBlockData(blocks, targetId, blockType)
  }

  const displayPostMenu = (post: any) => {
    if (!showPostMenu) return false

    if (!post?.member_group) {
      // ナビゲータの投稿はメニューを表示しない
      return post?.post_type !== "1"
    } else {
      return true
    }
  }

  const handleNavigateCreatePost = (post: any) => {
    navigate("/createPost", createUpdatingPostState(post, user, post.member_group, dispatch));
  }

  const formatEventDate = (start_date: any, end_date: any) => {
    const startDate = dayjs(start_date);
    const endDate = dayjs(end_date);

    if (startDate.isSame(endDate, "day")) {
      // If start and end dates are the same
      return startDate.format("YYYY年M月D日(ddd)");
    } else {
      // If start and end dates are different
      return `${startDate.format("YYYY年M月D日(ddd)")}~${endDate.format(
        "M月D日(ddd)"
      )}`;
    }
  };

  const getParticipantStatus = (post: any) => {
    const matchedUser = post.post_events?.[0].users?.find(
      (userItem: any) =>
        userItem?.user_id === user?.id &&
        (userItem?.status === "applied" ||
          userItem?.status === "Cancel-pending")
    )
    if (matchedUser) {
      return String(matchedUser.status)
    } else {
      return ""
    }
  }

  const searchEventParticipant = async (post: any) => {
    try {
      const res = await appServices.searchEventParticipant(
        post?.post_events[0]?.id,
        user?.id
      );

      if (!res) return

      navigate("/usereventcancellation", {
        state: {
          postEventUserId: res.id,
        },
      });
    } catch (error) {
      console.error(error);
    }
  };

  const getCreatorName = (post: any) => {
    return getPostCreatorName(post)
  }

  const displayPostStatus = () => {
    switch (post?.status) {
      case "Approved" :
        return `${T("approved_post")}`
      case "Rejected" :
        return `${T("rejected_post")}`
      case "Reported" :
        return `${T("reported_post")}`
      default :
        return `${T("post_in_process_of_judging")}`
    }
  }

  const handleNavigateEventDetail = () => {
    handleReview(post?.member_group);
    navigate("/eventpostdetails", { state: post.id })
  }

  const isUnableToLike = () => {
    // 自分の投稿にはいいね不可
    if (isPostCreator(post, user)) return true

    // 既に閉じられたグループの投稿にはいいね不可
    if (post?.member_group && isClosedGroup(post?.member_group?.closed_at)) return true

    return false
  }

  return (
    <div
      style={{
        paddingTop: 20,
        paddingBottom: 50,
        borderBottomColor: colors.grey[400],
        borderBottomStyle: "solid",
        overflow: "hidden",
        display: "block",
      }}
    >
      <ImageList style={style.displayBlock} cols={1}>
        <ImageListItem
          sx={style.marginBottom20}
        >
          <ul
            style={style.paddingLeft13}
          >
            <ListItem
              className=""
              alignItems="flex-start"
              style={style.listItem}
            >
              <ListItemAvatar style={style.listItemAvatar}>
                {post?.member_group ? (
                  <GroupIconImage
                    groupId={post?.member_group?.id}
                    alt={post?.member_group?.name}
                    style={style.groupIconImage}
                  />
                ) : (
                  <>
                    {post?.is_anonymous === 3 ? (
                      <Avatar style={style.margin0} alt="Remy Sharp" src={profile} />
                    ) : (
                      <Avatar alt="img" style={style.margin0} src={creator?.image !== null ? convertUserImage(creator?.image) : profile} />
                    )}
                  </>
                )}
              </ListItemAvatar>

              <ListItemText
                primary={
                  post?.member_group ? (
                    <>
                      {post?.member_group?.name}
                    </>
                  ) : (
                    <Typography sx={style.fontSize16} component="span" variant="body2" color="text.primary">
                      {getCreatorName(post)}
                    </Typography>
                  )
                }
              />

              {isPostCreator(post, user) && post?.post_events?.length === 0 && (
                <Button
                  style={style.fontSize10}
                  onClick={() => handleNavigateCreatePost(post) }
                  color={"secondary"}
                  variant="text"
                  startIcon={<EditIcon style={style.marginRight0} fontSize="small" />}
                >
                  {T("edit_post")}
                </Button>
              )}

              {showStatus && (
                <Stack direction={"row"} sx={style.alignItemsCenter}>
                  <Typography
                    style={{
                      color:
                        post.status === "Approved"
                          ? colors.green[500]
                          : post.status === "Rejected" || post.status === "Reported"
                            ? colors.red[500]
                            : colors.yellow[800]
                    }}
                  >
                    {displayPostStatus()}
                  </Typography>
                  <IconButton aria-label={`info about ${post.title}`}>
                    {post.status === "Approved" && <CheckCircleOutlineIcon style={style.approvedPostIconButton} />}
                    {(post.status === "Pending" || post.status === "Edit-pending") && <RemoveCircleOutlineIcon style={style.pendingPostIconButton} />}
                    {(post.status === "Rejected" || post.status === "Reported") && <HighlightOffIcon style={style.rejectedPostIconButton} />}
                  </IconButton>
                </Stack>
              )}

              {(showRanking && rank) && <IconButton style={style.ranking}>{rank}位</IconButton>}

              {displayPostMenu(post) &&
                <MultiMenu
                  targetUser={adjustUserInfo(creator, post?.member_group)}
                  groupInfo={post?.member_group ? post?.member_group : null}
                  post={post}
                  menuType={"post"}
                />
              }
            </ListItem>
          </ul>

          <div>
            <Thumbnail deleteItem={() => {}} item={post} type="posts" isBlocked={fetchBlock(post) !== undefined} />
          </div>

          {fetchBlock(post) === undefined && (
            <div style={style.marginHorizontal20}>
              <div style={style.justifyContentCenter}>
                <LikeDislikeButton
                  disabled={isUnableToLike()}
                  iconSize={"lg"}
                  liketype={"post"}
                  item={post}
                />
              </div>
              <Typography
                style={style.title}
              >
                {post?.title}
              </Typography>
              {post?.is_private && (
                <Box onClick={() => navigate("/viewpostuser", { state: { item: post } })} sx={style.privatePostBox}>
                  <Typography sx={style.privatePostUserText}>{TF(T("can_view_post_user_count"), post.post_private_users.length - 1)}</Typography>
                  <Typography sx={style.seePrivatePostUser}>{T("view_users")}</Typography>
                </Box>
              )}
              {showEventStatus &&
                <Typography
                  sx={style.date}
                >
                  {TF("{0}{1}", T("event_post_date"), formatEventDate(
                    post?.post_events[0]?.start_date,
                    post?.post_events[0]?.end_date
                  ))}
                </Typography>
              }

              {/* 本文 */}
              <PostDescSeeMore description={post?.details} />

              {/* タグ */}
              <div style={style.tag}>
                <PostTags tags={post?.post_tags || []} />
                <Separator color={farmColor.farm_gray100} sx={style.tagSeparator} />
              </div>

              {showEventStatus && getParticipantStatus(post) !== "" && (
                <>
                  <Separator color={colors.grey[400]} sx={style.marginTop2} />
                  <Box sx={style.padding15px20px}>
                    <Box sx={style?.detailsBox}>
                      {getParticipantStatus(post) === "applied" ? (
                        <Typography>{T("is_already_applied")}</Typography>
                      ) : (
                        <Typography>
                          {T("is_already_requested_to_cancel")}
                        </Typography>
                      )}
                      <Button
                        color="secondary"
                        sx={style.detailButton}
                        size="large"
                        variant="outlined"
                        onClick={() => searchEventParticipant(post)}
                        endIcon={
                          <ArrowForwardIosIcon
                            sx={style.detailButtonArrow}
                          />
                        }
                      >
                        {T("view_detail")}
                      </Button>
                    </Box>
                  </Box>
                  <Separator color={colors.grey[400]} sx={style.marginTop2} />
                </>
              )}

              {post?.post_events.length > 0 && (
                <span
                  style={style.eventMore}
                  onClick={() => handleNavigateEventDetail()}
                >
                  {T("read_more")}
                </span>
              )}

              <Stack direction="row" spacing={0}>
                {post?.enable_comments && <PostCommentButton post={post} />}

                {post?.enable_participants && (
                  <Box>
                    <IconButton
                      onClick={() => setShowVotesModal(post.id)}
                      aria-label="thumbs"
                    >
                      <HowToVoteIcon />
                      <Typography>{T("vote")}</Typography>
                    </IconButton>
                  </Box>
                )}
              </Stack>
              <Typography color={farmColor?.farm_gray200}>{createdAt(post?.created_at)}</Typography>

              {showVotesModal === post.id && (
                <ModalBackground onClick={() => setShowVotesModal(0)}>
                  <ModalContainer onClick={(e: any) => e.stopPropagation()}>
                    <VotesModel
                      post={post}
                      votedOptionId={votedOptionId}
                      closeModal={() => setShowVotesModal(0)}
                      onChange={(votedOptionId) => setVotedOptionId(votedOptionId)}
                    />
                  </ModalContainer>
                </ModalBackground>
              )}
            </div>
          )}
        </ImageListItem>
      </ImageList>
    </div>
  );
}

const style = {
  detailButton: {
    width: "80%",
    alignSelf: "center",
    margin: "0 auto",
    marginTop: "20px",
    display: "flex",
    borderRadius: 20,
    border: "2px solid",
  },
  detailButtonArrow: {
    position: "absolute",
    right: 0,
    top: 0,
    margin: "10px",
  },
  detailsBox: {
    border: "1px solid rgb(175, 201, 153)",
    background: "rgb(231, 240, 232)",
    display: "flex",
    borderRadius: 3,
    alignItems: "center",
    gap: "15px",
    flexDirection: "column",
    padding: "20px 10px",
  },
  displayBlock: {
    display: "block"
  },
  marginBottom20: {
    marginBottom: "20px",
  },
  paddingLeft13: {
    paddingLeft: 13,
  },
  listItem: {
    ...styles.detailListItem,
    paddingLeft: 0,
    paddingRight: 20,
    justifyContent: "center",
    alignItems: "center",
  },
  listItemAvatar: { margin: "0 7px 0 0", minWidth: 40 },
  groupIconImage: {
    margin: 0,
    width: 40,
    height: 40,
    borderRadius: "50%"
  },
  margin0: { margin: 0 },
  fontSize16: { fontSize: 16 },
  fontSize10: { fontSize: 10 },
  marginRight0: { marginRight: 0 },
  alignItemsCenter: { alignItems: "center" },
  approvedPostIconButton: {
    color: colors.green[500],
    fontSize: 22
  },
  pendingPostIconButton: {
    color: colors.yellow[800],
    fontSize: 22
  },
  rejectedPostIconButton: {
    color: colors.red[500],
    fontSize: 22
  },
  ranking: {
    fontSize: 12,
    backgroundColor: "#B7E68D"
  },
  marginHorizontal20: { margin: "0 20px" },
  justifyContentCenter: { justifyContent: "center" },
  title: {
    marginLeft: 6,
    marginRight: 6,
    fontSize: 20,
    fontWeight: "600",
    overflowWrap: "break-word" as const
  },
  privatePostBox: {
    display: "flex",
    margin: "0px 5px"
  },
  privatePostUserText: {
    fontSize: 12,
    marginRight: "10px"
  },
  seePrivatePostUser: {
    fontSize: 12,
    color: farmColor.farm_gray200
  },
  date: {
    color: "#A2A2A2",
    fontSize: 12,
    marginLeft: 1
  },
  tag: { margin: "10px 0 5px" },
  tagSeparator: {
    width: "auto",
    height: "1.5px",
    margin: `0 calc(50% - 50vw)`
  },
  marginTop2: { marginTop: 2 },
  padding15px20px: { padding: "15px 20px" },
  eventMore: {
    fontSize: 12,
    color: farmColor.farm_gray200,
    cursor: "pointer",
    display: "block",
    marginTop: 8,
  }
};